import React from "react";
import media from "../../../media";
import { Rate } from "antd";
import moment from "moment";
import { ImageSlider } from "../../../components/atoms/sliders/imageSlider";
import { VideoSlider } from "../../../components/atoms/sliders/videoSlider";
import TableLoader from "../../../components/atoms/Loader/tableLoader";

export const ReviewTable = ({ list, offset, loading }) => {
  return (
    <div>
      {" "}
      <table className="table table-bordered m-0 border radius-remove all_domain_table">
        <thead className="text-white bg-gray-700">
          <tr>
            <th className="all_table_id_number text-center">S.No.</th>
            <th className="width text-center">Product Image</th>
            <th className="width text-center">Product Name</th>
            <th className="width text-center">Reviewer</th>
            <th className="width text-center">Rating &amp; Review</th>
            <th className="width text-center">Review Image</th>
            <th className="width text-center">Review Video</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}>
                <TableLoader />
              </td>
            </tr>
          ) : list?.length > 0 ? (
            list.map((datalist, index) => {
              function setRating(rate) {
                switch (rate) {
                  case "ONE":
                    return 1;
                  case "TWO":
                    return 2;
                  case "THREE":
                    return 3;
                  case "FOUR":
                    return 4;
                  case "FIVE":
                    return 5;
                  default:
                    break;
                }
              }
              return (
                <>
                  <tr key={index.toString()}>
                    <td className="text-center">{index + 1 + offset * 10}</td>
                    <td className="text-center">
                      <div className="symbol symbol-70">
                        <img
                          src={
                            datalist?.productImageUrl
                              ? datalist?.productImageUrl
                              : media?.Default
                          }
                          alt=""
                          className="max-w-70px rounded-0 w-100 h-100"
                        />
                      </div>
                    </td>
                    <td className="font-weight-bolder text-center">
                      <p className="m-0">{datalist?.productName?.en}</p>
                    </td>
                    <td className="text-center">
                      {datalist?.name?.en} <br />
                     

                       {datalist?.userMobile
                        ? `${datalist?.userMobile.slice(0, 2)}******${datalist?.userMobile.slice(-2)}`
                        : ""}

                    </td>
                    <td className="text-center">
                      <div className="">
                        <p className="m-0">
                          <Rate
                            disabled
                            defaultValue={setRating(datalist?.reviewStar)}
                          />
                        </p>
                        <p className="my-2">{datalist?.message}</p>
                        <p className="m-0">
                          {moment.utc(datalist?.lastUpdatedDate).local().format(
                            "DD/MM/YYYY hh:mm A"
                          )}
                        </p>
                      </div>
                    </td>
                    <td className="text-center">
                      {datalist?.imageUrl[0] && (
                        <div
                          className="symbol symbol-80 flex-shrink-0 mx-auto"
                          data-toggle="modal"
                          data-target={`#reviewslider${index}`}
                        >
                          <img
                            src={datalist?.imageUrl[0]}
                            className="rounded-0 cursor-pointer"
                            style={{ objectFit: "contain" }}
                            alt=""
                          />
                          <span className="label label-danger attachment-label">
                            {datalist?.imageUrl?.length}
                          </span>
                        </div>
                      )}
                    </td>
                    <td className="text-center">
                      {datalist?.videoUrl[0] && (
                        <div
                          className="symbol symbol-80 flex-shrink-0 mx-auto"
                          data-toggle="modal"
                          data-target={`#reviewvideoslider${index}`}
                        >
                          <i className="fa fas fa-play-circle text-success icon-3x cursor-pointer"></i>
                        </div>
                      )}
                    </td>
                  </tr>
                  <ImageSlider
                    id={`reviewslider${index}`}
                    list={datalist}
                    name={"Review"}
                  />
                  {/**More Images Slider End**/}

                  {/**Video Slider Start**/}
                  <VideoSlider
                    id={`reviewvideoslider${index}`}
                    list={datalist}
                    name={"Review"}
                  />
                  {/**Video Slider End**/}
                </>
              );
            })
          ) : (
            <tr className="text-center">
              <td colSpan={7}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
